import { render, staticRenderFns } from "./DialogTemplateWithFooter.vue?vue&type=template&id=a0b3a2a4&scoped=true"
import script from "./DialogTemplateWithFooter.vue?vue&type=script&lang=js"
export * from "./DialogTemplateWithFooter.vue?vue&type=script&lang=js"
import style0 from "./DialogTemplateWithFooter.vue?vue&type=style&index=0&id=a0b3a2a4&prod&lang=scss&scoped=true"
import style1 from "./DialogTemplateWithFooter.vue?vue&type=style&index=1&id=a0b3a2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b3a2a4",
  null
  
)

export default component.exports